import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { LinkButton } from '../ui/Button';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
import { telHref } from '../../utils/format';
const nav = [{
  label: 'Opgaver',
  href: '#opgaver'
}, {
  label: 'Om LYKKEVÆRK',
  href: '#om'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}];
export function Header() {
  const {
    settings
  } = useAdminData();
  return <header className="sticky top-0 z-50 border-b border-line/70 bg-canvas/90 backdrop-blur-md" data-id="element-360" data-mp="1kmweirus78ow">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between gap-6 px-5 md:h-20 lg:px-8" data-id="element-361" data-mp="1ooi154x4b1ca">
        <a href="#top" aria-label={`${settings.companyName} — til toppen`} data-id="element-362" data-mp="1tjp0k0jctjve">
          <img src={company.logoWide} alt={settings.companyName} className="h-9 w-auto md:h-12" data-id="element-363" data-mp="1yjtfvn8j08k1" />
        </a>

        <nav aria-label="Sektioner" className="hidden items-center gap-1 md:flex" data-id="element-364" data-mp="3vezegie6r2xm">
          {nav.map(item => <a key={item.href} href={item.href} className="rounded-full px-3.5 py-2 text-[15px] text-ink-soft transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-365" data-mp="2gmvueyswvv11">
              {item.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-366" data-mp="26uq5xz1vbvql">
          {settings.phone && <>
              <a href={telHref(settings.phone)} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-line bg-white text-ink transition-colors duration-200 ease-smooth hover:border-ink/30 sm:hidden" aria-label={`Ring til ${settings.companyName} på ${settings.phone}`} data-id="element-367" data-mp="2zlrlw2ddxvb6">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-368" data-mp="2llgxr73gmutp" />
              </a>
              <a href={telHref(settings.phone)} className="hidden items-center gap-2 text-[15px] text-ink-soft transition-colors duration-200 ease-smooth hover:text-ink lg:inline-flex" data-id="element-369" data-mp="1f6o8gbjyslpv">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-370" data-mp="1bm6030j1oot7" />
                {settings.phone}
              </a>
            </>}
          <LinkButton href="#kontakt" size="md" className="hidden sm:inline-flex" data-id="element-371" data-mp="12o2clyoi1hyr">
            Få et tilbud
          </LinkButton>
        </div>
      </div>
    </header>;
}